var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-main-layout',[_vm._v(" fds ")])
}
var staticRenderFns = []

export { render, staticRenderFns }